import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HandleDates } from '@app/common/services/handle-dates.service';
import { PlexEnvironment } from '@app/env';
import { IItemRateDto } from "@app/shared/models/dtos/dtos";
import { IProjectFieldDto } from "@app/shared/models/dtos/project-field";
import { IProjectFieldToFieldXref } from "@app/shared/models/dtos/project-field-to-field-xref";
import { Observable } from "rxjs";

@Injectable()
export class ItemRateManagementService {
  private http = inject(HttpClient);
  private handleDates = inject(HandleDates);
  public environment = inject(PlexEnvironment);

  private BASE_URL = '';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor() {
    this.BASE_URL = this.environment.apiUrl;
  }

  public findItemDtos(itemId: number): Observable<ItemRatesDtoResponse> {
    let url = `${this.BASE_URL}itemRateManagement/finditemratedtos/` + itemId;
    return this.http.get<ItemRatesDtoResponse>(url);
  }

  public upsertItemRateDtos(upsertItems: Array<IItemRateDto>): Observable<ItemRatesDtoResponse> {
    let url = `${this.BASE_URL}itemRateManagement/upsertitemrates`;
    return this.http.post<ItemRatesDtoResponse>(url, upsertItems);
  }

  public getProjectFields(functionId: number): Observable<IProjectFieldDto[]> {
    let url = `${this.BASE_URL}itemRateManagement/ProjectFields?functionId=` + functionId;
    return this.http.get<IProjectFieldDto[]>(url);
  }

  public getProjectFieldLookup(projectFieldId: number, functionId: number): Observable<any[]> {
    let url = `${this.BASE_URL}itemRateManagement/ProjectFieldLookup?projectFieldId=${projectFieldId}&functionId=${functionId}`;
    return this.http.get<any[]>(url);
  }

  public async getItemProjectFieldIds(itemId: number, populateLookups: boolean): Promise<any[]> {
    let url = `${this.BASE_URL}itemRateManagement/ItemProjectFields?itemId=` + itemId + `&populateLookups=` + populateLookups;
    return this.http.get<any[]>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async getItemRateProjectFields(itemId: number): Promise<any[]> {
    let url = `${this.BASE_URL}itemRateManagement/ItemRateProjectFields?itemId=` + itemId;
    return this.http.get<any[]>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public postItemProjectFields(iProjectFieldToFieldXrefs: Array<IProjectFieldToFieldXref>): Observable<any> {
    let url = `${this.BASE_URL}itemRateManagement/ItemProjectFields`;
    return this.http.post<any>(url, iProjectFieldToFieldXrefs);
  }

  public deleteItemProjectField(iProjectFieldToFieldXref: IProjectFieldToFieldXref): Observable<any> {
    let url = `${this.BASE_URL}itemRateManagement/DeleteItemProjectField?deleteRelatedRateValues=true`;
    return this.http.request('DELETE', url, {
      headers: this.headers,
      body: iProjectFieldToFieldXref
    });

  }

  public async postItemRateProjectFields(upsertItems: Array<IItemRateDto>): Promise<any> {
    let url = `${this.BASE_URL}itemRateManagement/ItemRateProjectFields`;
    return await this.http.post<any>(url, upsertItems).toPromise();
  }
}

export interface ItemRatesDtoResponse {
  Results: Array<IItemRateDto>;
}